import { isLaunchableUrl } from './launch-url';
import type { AuthProduct } from './use-products';

/**
 * The single source of the post-login product-routing decision, shared by the
 * `/launch` resolver and the `/select-product` chooser. Pure and synchronous.
 */
export type ProductDestination =
  | { kind: 'external'; url: string }
  | { kind: 'account' }
  | { kind: 'chooser' };

export function resolveProductDestination(input: {
  isError: boolean;
  total: number;
  items: AuthProduct[];
}): ProductDestination {
  if (input.isError) return { kind: 'account' };
  if (input.total === 1) {
    const url = input.items[0]?.portal_url;
    return isLaunchableUrl(url) ? { kind: 'external', url: url! } : { kind: 'account' };
  }
  if (input.total > 1) return { kind: 'chooser' };
  return { kind: 'account' };
}
